import { useEffect, useState } from 'react';
import { getEnv } from '../../environment';
import request from '../../services/request';

const campaignUrl = '/customize/current/seasonal';

const useGetCustomizeCampaignInfo = () => {
  const [campaign, setCampaignData] = useState<CampaignInfoType>(defaultCampaignInfo);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const fetchCampingInfo = async () => {
    setIsLoading(true);
    try {
      const response = await request<CampaignInfoType>({
        path: `${getEnv().REACT_APP_CUSTOMIZE_API_URL}${campaignUrl}`,
      });
      setCampaignData(response as CampaignInfoType);
    } catch (error: unknown) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCampingInfo();
  }, []);

  return { campaign, isLoading, error, fetchCampingInfo };
};

interface Season {
  id: number;
  customizeCampaignId: number;
  seasonDisplay: string;
  seasonDisplayOrigin: string;
  periods: unknown[];
  seasonCode: string;
}

type Campaign = {
  id: number;
  title: string;
  surveyId: number;
  published: boolean;
  selectStartDate: string;
  selectEndDate: string;
  startDate: string;
  endDate: string;
};

type Box = {
  id: number;
  name: string;
  image: string;
  shiplistSku: string;
  campaignId: number;
  year: number;
  quarter: number;
};

type CampaignInfoType = {
  season: Season;
  campaign: Campaign;
  box: Box;
};

const emptySeason = {
  id: 0,
  customizeCampaignId: 0,
  seasonDisplay: '',
  seasonDisplayOrigin: '',
  periods: [],
  seasonCode: '',
};

const emptyCampaign = {
  id: 0,
  title: '',
  surveyId: 0,
  published: false,
  selectStartDate: '',
  selectEndDate: '',
  startDate: '',
  endDate: '',
};

const emptyBox = {
  id: 0,
  name: '',
  image: '',
  shiplistSku: '',
  campaignId: 0,
  year: 0,
  quarter: 0,
};

const defaultCampaignInfo = {
  season: emptySeason,
  campaign: emptyCampaign,
  box: emptyBox,
};

export { useGetCustomizeCampaignInfo };
export type { CampaignInfoType };
